module.exports = __webpack_public_path__ + "static/img/08062D_2_3_R_20191001_LC.cf4beb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/08062D_2_3_R_20191001_LC.png
// module id = Vx4S
// module chunks = 0